import { render, staticRenderFns } from "./e-photoshop-color-picker.vue?vue&type=template&id=215ef5a0"
import script from "./e-photoshop-color-picker.vue?vue&type=script&lang=js"
export * from "./e-photoshop-color-picker.vue?vue&type=script&lang=js"
import style0 from "./e-photoshop-color-picker.vue?vue&type=style&index=0&id=215ef5a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports